/* This file is autogenerated, see readme.md for instructions */
import AbTestSvgIcon from '@bloomreach/banana-theme/icons/ab-test.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AbTestIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AbTestSvgIcon />
    </Icon>
  );
});

AbTestIcon.displayName = 'AbTestIcon';

export default AbTestIcon;
